export default __webpack_public_path__ + "images/62a4a8fe49a9fc27666c066003e033f7.png";